module.exports = "/images/no-pic.png?6bb14018c480d80bcb138dd000e38a18";